import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { selectEntitiesByFilters } from '../../../store/views/entityView';
import { promotionsQuery } from '../../../utils/entitiesFiltersUtils';
import { isPromotionSeen, markPromotionSeen } from '../../../utils/promotionUtils/promotionStorage';
import ContentPromotionPopup from './ContentPromotionPopup';

const ContentPromotionHost = () => {

    const [refreshKey, setRefreshKey] = useState(0);
    const [currentIndex, setCurrentIndex] = useState(0);
    const { user } = useSelector(state => state.auth);
    const promotions = useSelector(state =>
        selectEntitiesByFilters(state, promotionsQuery).filter(entity =>
            !isPromotionSeen(user?.exidentifier, entity.id)
        )
    );
    const safeIndex = Math.min(currentIndex, Math.max(promotions.length - 1, 0));
    const currentPromotion = promotions[safeIndex];

    const handleClose = () => {
        markPromotionSeen(user?.exidentifier, currentPromotion?.id);
        setCurrentIndex(0);
        setRefreshKey(value => value + 1);
    };

    const handlePrev = () => setCurrentIndex(index => Math.max(0, index - 1));
    const handleNext = () => setCurrentIndex(index => Math.min(promotions.length - 1, index + 1));

    return currentPromotion &&
        <ContentPromotionPopup
            key={refreshKey}
            promotion={currentPromotion}
            onClose={handleClose}
            onPrev={handlePrev}
            onNext={handleNext}
            currentIndex={safeIndex}
            totalCount={promotions.length}
        />;
};

export default ContentPromotionHost;
